import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { navigateAfterAuth } from "../../../utils/postAuthNavigation";
import {
  consumeGoogleSignupPending,
  trackSignUpComplete,
} from "../../../utils/signupTracking";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export default function AuthCallback() {
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const state = params.get("state");

    if (!code) {
      consumeGoogleSignupPending();
      navigate("/login", { replace: true });
      return;
    }

    const wasGoogleSignup = consumeGoogleSignupPending();

    fetch(`${API_BASE_URL}/auth/callback`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      credentials: "include",
      body: JSON.stringify({ code })
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Auth failed");
        if (wasGoogleSignup) {
          trackSignUpComplete("google");
        }
        if (state === "change-password") {
          navigate("/security", {
            replace: true,
            state: { passwordChanged: true }
          });
        } else {
          await navigateAfterAuth(navigate, null);
        }
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [navigate]);

  return <p>Autenticando...</p>;
}
